export default __webpack_public_path__ + "static/media/Holly 9781843626619.be663998.jpg";